export const LEAGUES_STATUS = {
    BLOCKED: 'Blocked',
    ACTIVE: 'Active',
    DELETED: 'Deleted',
    WAITING: 'Waiting',
};